import React from 'react'
import { toJS } from 'mobx'
import './index.scss'

//other libraries
import { inject, observer } from 'mobx-react'

//api
import { api } from '../../../functions/api'

//material-ui
import CircularProgress from '@material-ui/core/CircularProgress'

//custom components
import CustomTabs from '../../../components/basic/customTabs'
import ProductPrices from './prices'
import ProductContent from './content'
import ProductBasicInfo from './basic'
import Gallery from './gallery'
import Parameters from './parameters/Parameters'
import TechnicalDocuments from './techDocs/TechnicalDocuments'
import ProductVignettes from './vignettes'
import Monitoring from './monitoring/Monitoring'
import ProductWarehouse from './warehouse'

@inject('internal')
@inject('translate')
@observer
export default class ProductEdit extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }
  }
  
  tabsConfig = []
  
  
  componentDidMount() {
    this.props.internal.setRoute(this.props.history, this.props.location.pathname)
    this.setupTabs()
    this.loadBasicData()
  }
  
  setupTabs = () => {
    let permissions = toJS(this.props.internal.user.data.permissions.products)
    
    if (permissions.update) {
      this.tabsConfig.push(
        {
          label: this.props.translate.i18n.MODULES.PRODUCTS.TABS.BASIC_INFO,
          url: 'tab=0',
          value: 0,
        },
        {
          label: this.props.translate.i18n.MODULES.PRODUCTS.TABS.PRICES,
          url: 'tab=1',
          value: 1,
        },
        {
          label: this.props.translate.i18n.MODULES.PRODUCTS.TABS.CONTENT,
          url: 'tab=2',
          value: 2,
        },
        {
          label: this.props.translate.i18n.MODULES.PRODUCTS.TABS.GALLERY,
          url: 'tab=3',
          value: 3,
        },
        {
          label: this.props.translate.i18n.MODULES.PRODUCTS.TABS.PARAMETERS,
          url: 'tab=4',
          value: 4,
        },
        {
          label: this.props.translate.i18n.MODULES.PRODUCTS.TABS.TECH_DOCS,
          url: 'tab=5',
          value: 5,
        },
        {
          label: this.props.translate.i18n.MODULES.PRODUCTS.TABS.VIGNETTES,
          url: 'tab=6',
          value: 6,
        },
        {
          label: this.props.translate.i18n.MODULES.PRODUCTS.TABS.PRICE_MONITORING,
          url: 'tab=7',
          value: 7,
        },
      )
    }
    
    if (permissions.manage_warehouse || permissions.update) {
      this.tabsConfig.push({
        label: this.props.translate.i18n.MODULES.PRODUCTS.TABS.WAREHOUSE,
        url: 'tab=8',
        value: 8,
      })
    }
  }
  
  loadBasicData = async () => {
    this.setState({ loading: true })
    let load_data = await api({
      method: 'get',
      url: 'products/' + this.props.match.params.idProduct,
      authorization: this.props.internal.user.access_token,
    })
    
    if (load_data.success && load_data.success === true) {
      this.props.internal.setDataForSimpeTable(load_data.data.data)
      this.setState({ loading: false })
    }
    
    this.setState({ loading: false })
  }
  
  render() {
    const routerData = {
      history: this.props.history,
      location: this.props.location,
      match: this.props.match,
    }
    
    return (
      <div className={'product-detail-container'}>
        {this.state.loading ?
          <CircularProgress className={'circular-progress'}/>
          :
          <div className={'products-edit'}>
            {/* + " - "+ toJS(this.props.internal.dataForSimpeTable.name) */}
            <CustomTabs
              title={'EAN ' + toJS(this.props.internal.dataForSimpeTable.code)}
              tabsConfig={this.tabsConfig}
              routerData={routerData}
              module={'/products'}
            >
              {this.state.loading ? null :
                <ProductBasicInfo routerData={routerData}/>
              }
              {this.state.loading ? null :
                <ProductPrices routerData={routerData}/>
              }
              {this.state.loading ? null :
                <ProductContent routerData={routerData}/>
              }
              {this.state.loading ? null :
                <Gallery routerData={routerData}/>
              }
              {this.state.loading ? null :
                <Parameters routerData={routerData}/>
              }
              {this.state.loading ? null :
                <TechnicalDocuments routerData={routerData}/>
              }
              {this.state.loading ? null :
                <ProductVignettes routerData={routerData}/>
              }
              {this.state.loading ? null :
                <Monitoring routerData={routerData}/>
              }
              {this.state.loading ? null :
                <ProductWarehouse routerData={routerData}/>
              }
            </CustomTabs>
          
          
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/products/edit/index.js